import {getResult} from "./cookie"
// 注入google consent回调
const consentListeners = [];
window.addConsentListener = (callback) => {
    consentListeners.push(callback);
};

window.getConsentData = () => {
    const lastResult = getResult();
    return (lastResult?.google || []).join(",")
};
// 是否可以不使用这个回调，只需要在tag manger中获取cookie做初始化就行
export const onGoogleConsentChange = (consent = []) => {
    consentListeners.forEach((callback) => {
        callback({
            granted: consent.join(",")
        });
    });
};